// extracted by mini-css-extract-plugin
export default {"root":"classes_root__v+x7M","links":"classes_links__fBdhT","cursor":"classes_cursor__nx+k1"};